<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelEmpresa"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="name"
    track-by="value"
    :disabled="isDisabled"
    placeholder=""
    class="multiselect-primary"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }"
      ><span class="multiselect__tag"
        ><span class="text-truncate mr-1 mb-1">{{ option.name }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeEmpresa(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'confirmDelete',
    'msgDelete',
    'notDeleteEmpresa'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false,
      initialItems: []
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'empresasSelecionadas', null);
        return;
      }
      this.$emit('selectChange', 'empresasSelecionadas', e);
    },
    labelEmpresa({ name }) {
      return `${name}`;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'empresasSelecionadas', value);
      } else {
        if (value) {
          if (value.value) {
            this.selected = this.options.find((option) => option.value === value.value);
          } else {
            this.selected = this.options.find((option) => option.value === value);
          }
        } else {
          this.selected = this.options.find((option) => option.value === null);
        }
        this.$emit('input', this.selected);
      }
    },
    clearAll() {
      this.value = [];
    },
    async setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getEmpresas({
          columns: 'id,nome',
          order: 'nome'
        })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ name: this.$i18n.t(this.emptyLabel), value: null }];
          }

          res.data.forEach((e) => {
            this.options.push({
              name: `${e.id} - ${e.nome}`,
              value: e.id
            });
          });
          this.showOptionsSel(this.alreadyAdded);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    showOptionsSel(optionsSel) {
      if (optionsSel.length >= 0 || optionsSel != undefined) {
        this.initialItems = [];
        optionsSel.forEach((id) => {
          const item = this.options.find((e) => {
            return e.value === id;
          });
          if (item) {
            this.initialItems.push(item);
          }
        });
        this.setValue(this.initialItems);
      }
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.value === element.value);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.value === option.value);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.value != el.value);
        }
      });
      this.setValue(valueCp);
      this.options = [option, ...this.options];
    },
    removeEmpresa(option) {
      if (option.value == this.notDeleteEmpresa) {
        this.$util.formWarn({
          msgTitle: 'Atenção',
          msgContent: 'Não é permitido excluir esta empresa'
        });
        return;
      }
      if (this.confirmDelete) {
        const mensagem = this.$createElement('span', [
          this.$i18n.t('Empresa') + ': ',
          this.$createElement('strong', option.name),
          this.$createElement('br'),
          this.$createElement('br'),
          this.$createElement('strong', this.$i18n.t('Atenção') + ': '),
          this.$createElement('br'),
          this.$createElement('strong', this.$i18n.t(this.msgDelete)),
          this.$createElement('br'),
          this.$createElement('br'),
          this.$i18n.t('Confima esta ação?')
        ]);
        this.$bvModal
          .msgBoxConfirm(mensagem, {
            title: this.$i18n.t('Excluir Empresa'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: this.$i18n.t('Confirmar'),
            cancelTitle: this.$i18n.t('Fechar'),
            footerClass: 'p-2',
            hideHeaderClose: false
          })
          .then((value) => {
            if (value) {
              this.removeOption(option);
            }
          })
          .catch((err) => console.log(err));
      } else {
        this.removeOption(option);
      }
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    alreadyAdded: function (value) {
      this.showOptionsSel(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
